import React, { CSSProperties, FunctionComponent } from 'react';
import { Button } from 'rs-emd-ui-atoms';
import { IButtonDataWidget } from '../../../../models/campaign-pages/widgets/button/button-data.model';
import styles from './button-widget-component.module.scss';

export type ButtonWidgetProps = { button: IButtonDataWidget; isContainerFullHeight?: boolean };

//TODO : If models for button match those in HeroBanner & ImageAndTextbox replace the button instances with this widget
export const ButtonWidget: FunctionComponent<ButtonWidgetProps> = ({ isContainerFullHeight = true, ...props }) => {
  return (
    <div
      className={`${styles['button-widget-container']} ${
        styles['desktop-horiz-alignment-' + (props.button.buttonHorizontalAlignment?.desktop ?? 'center')]
      } ${styles['mobile-horiz-alignment-' + (props.button.buttonHorizontalAlignment?.mobile ?? 'center')]} ${
        styles['desktop-vert-alignment-' + (props.button.buttonVerticalAlignment?.desktop ?? 'center')]
      } ${styles['mobile-vert-alignment-' + (props.button.buttonVerticalAlignment?.mobile ?? 'center')]} `}
      style={{ '--container-height': isContainerFullHeight ? '100%' : 'auto' } as CSSProperties}>
      <Button
        href={props.button.link?.URL ?? undefined}
        target={props.button.link?.target ?? undefined}
        text={props.button.button?.type !== 'buttonWithIcon' && props.button.button?.text ? props.button.button?.text : undefined}
        icon={props.button.button?.type !== 'buttonWithText' && props.button.button?.icon ? props.button.button?.icon : undefined}
        buttonType={props.button.button?.style ?? undefined}
        isExternalLink={true}
        size={props.button.button?.type === 'buttonWithIcon' ? 'small-icon' : 'default'}
        iconPosition={props.button.button?.type === 'buttonWithTextAndIconRight' ? 'right' : 'left'}
      />
    </div>
  );
};

export default ButtonWidget;
